// extracted by mini-css-extract-plugin
module.exports = {"nft-offers-list":"ReceivedOffers_nft-offers-list__37TYb"};